import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ToggleLocationContextType {
  locationEnabled: boolean;
  toggleLocation: () => void;
  setLocationEnabled: (enabled: boolean) => void;
}

const ToggleLocationContext = createContext<
  ToggleLocationContextType | undefined
>(undefined);

export const ToggleLocationProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [locationEnabled, setLocationEnabled] = useState<boolean>(false);

  const toggleLocation = () => {
    setLocationEnabled((prev) => !prev);
  };

  return (
    <ToggleLocationContext.Provider
      value={{
        locationEnabled,
        toggleLocation,
        setLocationEnabled,
      }}
    >
      {children}
    </ToggleLocationContext.Provider>
  );
};

export const useToggleLocation = (): ToggleLocationContextType => {
  const context = useContext(ToggleLocationContext);
  if (!context) {
    throw new Error(
      'useToggleLocation must be used within a ToggleLocationProvider'
    );
  }
  return context;
};
